'use client';

import {useSearchParams} from 'next/navigation';
import {useEffect} from 'react';

import {OmicronContent} from '@web-catalog/api';
import {getOmicronABResponse} from '@web-catalog/api/omicronApi/omicronApiAB';

import {extractConfigOverridesFromQuery} from '@web-catalog/utils/omicron';

import {useSetOmicronABAtom} from '@web-catalog/store/omicronAB';

import {setOidSegments} from '@web-catalog/utils';

export const OmicronClientAB = () => {
  const setOmicronAB = useSetOmicronABAtom();
  const params = useSearchParams();

  useEffect(() => {
    getOmicronABResponse().then((data) => {
      setOidSegments(data.segments);
      const configPatch = extractConfigOverridesFromQuery(params);

      if (Object.keys(configPatch).length) {
        console.warn('Patching ab config: ', configPatch);
        data.config = {
          ...data.config,
          ...configPatch,
        } as OmicronContent;
      }

      setOmicronAB(data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};
